import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClassesRoutingModule } from './classes-routing.module';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { ClassTemplateListComponent } from './class-template-list/class-template-list.component';
import { AddUpdateClasstemplateComponent } from './add-update-classtemplate/add-update-classtemplate.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EditSyllabusComponent } from './edit-syllabus/edit-syllabus.component';
import { AddUpdateClassbystudentComponent } from './add-update-classbystudent/add-update-classbystudent.component';
import { AddUpdateClassbybatchComponent } from './add-update-classbybatch/add-update-classbybatch.component';
import { ViewTopicsComponent } from './view-topics/view-topics.component';


@NgModule({
  declarations: [
    AddComponent,
    ListComponent,
    ClassTemplateListComponent,
    AddUpdateClasstemplateComponent,
    EditSyllabusComponent,
    AddUpdateClassbystudentComponent,
    AddUpdateClassbybatchComponent,
    ViewTopicsComponent
  ],
  imports: [
    CommonModule,
    ClassesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    PipeModule,
    NgxDatatableModule, 
    NgxSpinnerModule,
    MatMenuModule,
    DragDropModule

  ]
})
export class ClassesModule { }
